module.exports = "<!-- Copyright (C) 2016 NooBaa -->\n<span ko.visible=\"visible\" ko.css=\"css\" ko.text=\"text\"></span>\n";
